import React from 'react';
import styled from 'styled-components';
import { NonReact, Tap } from '../';

class RawHTML {
  create(el, props) {
    el.innerHTML = props.html;
  }
}

const Wrapper = styled.div`
  padding-top: 50px;
  position: absolute;
  z-index: 50;
  width: 100%;
  height: 100%;
  top: ${({ theme }) => theme.termsTop || '0'};
  left: 0;
  background: ${({ theme }) => theme.termsBackground || 'rgba(0,0,0,0.5)'};
  padding: 50px;
  box-sizing: border-box;

  .boring {
    background: white;
    width: 90%;
    height: 1200px;
    overflow-y: scroll;
    padding: 40px;
    margin: 0 auto;

    h1 {
      font-size: 30px;
      margin: 20px 0;
      font-weight: bold;
      text-align: center;
    }

    h2 {
      font-size: 25px;
      margin: 20px 0;
      font-weight: bold;
      text-align: center;
    }

    p {
      font-size: 20px;
      margin: 10px 0;
    }
  }

  .close {
    text-align: center;
    text-transform: uppercase;
    width: 700px;
    margin: 50px auto 0 auto;
    background: ${({ theme }) => theme.buttonBackground || '#FE0000'};
    color: ${({ theme }) => theme.buttonTextColor || 'white'};
    padding: 30px 25px;
    font-family: ${({ theme }) => theme.font || 'Roboto Bold'};
    text-transform: ${({ theme }) =>
      theme.buttonUppercase ? 'uppercase' : 'none'};
    background-size: contain;
    font-size: 45px;
    cursor: pointer;
    line-height: 48px;
    border-radius: 10px;
  }
`;

const Terms = ({ terms, onClose }) => (
  <Wrapper>
    <NonReact className="boring" delegate={RawHTML} html={terms} />
    <Tap className="close" onTap={onClose}>
      U redu
    </Tap>
  </Wrapper>
);

export default Terms;
